import { BottomSheet, BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { type UseModalState } from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";

interface LogoutConfirmationBottomSheetProps {
  modalState: UseModalState;
  onLogout: () => Promise<void>;
  isLoading: boolean;
}

export function LogoutConfirmationBottomSheet(props: LogoutConfirmationBottomSheetProps) {
  const { modalState, onLogout, isLoading } = props;

  return (
    <BottomSheet modalState={modalState}>
      <BottomSheetIllustrationContent
        illustrationType="person-destructive"
        title="Log out?"
        description="Are you sure you want to log out?"
      />
      <DialogFooter orientation="vertical" sx={{ marginTop: 10 }}>
        <LoadingButton
          fullWidth
          variant="outlined"
          size="large"
          sx={{
            color: (theme) => theme.palette.error.light,
            borderColor: (theme) => theme.palette.border?.primary,
          }}
          isLoading={isLoading}
          onClick={async () => {
            await onLogout();
            modalState.closeModal();
          }}
        >
          Log out
        </LoadingButton>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          onClick={() => {
            modalState.closeModal();
          }}
        >
          Cancel
        </Button>
      </DialogFooter>
    </BottomSheet>
  );
}
